import request from '../request'

//查询所有学科门类
export function selectMajorForm(params) {
  return request({ url: '/api/Mojor/selectMajorForm',method: 'post',data: params})
}
//根据学科门类查询一级学科
export function selectOneMajor(params) {
  return request({ url: '/api/Mojor/selectOneMajor',method: 'post',data: params})
}
//根据门类和一级学科查询专业
export function selectMajorList(params) {
  return request({ url: '/api/Mojor/selectMajorList',method: 'post',data: params})
}
//专业详情
export function Mojor_detail(params) {
  return request({ url: '/api/Mojor/detail',method: 'post',data: params})
}
export function adminDetail(params) {
  return request({ url: '/api/Mojor/adminDetail',method: 'post',data: params})
}
//查位次
export function OneQuarter_index(params) {
  return request({ url: '/api/OneQuarter/index',method: 'post',data: params})
}
//招生计划列表
export function RecruitData_index(params) {
  return request({ url: '/api/RecruitData/index',method: 'post',data: params})
}
//招生计划详情
export function RecruitData_detail(params) {
  return request({ url: '/api/RecruitData/detail',method: 'post',data: params})
}
//批次线查询
export function OmitData_index(params) {
  return request({ url: '/api/OmitData/index',method: 'post',data: params})
}
//征集计划查询
export function Collectionplan_index(params) {
  return request({ url: '/api/Collectionplan/index',method: 'post',data: params})
}
//院校排行
export function paiListColl(params) {
  return request({ url: '/api/Collegiate/paiListColl',method: 'post',data: params})
}
//专业排行
export function zhuangyePai(params) {
  return request({ url: '/api/Colleges/zhuangyePai',method: 'post',data: params})
}
//查询特殊专业列表
export function Mojor_teshuList(params) {
  return request({ url: '/api/Mojor/teshuList',method: 'post',data: params})
}


export function selectGzMajorForm(params) {
  return request({ url: '/api/Mojor/selectGzMajorForm',method: 'post',data: params})
}
//根据学科门类查询一级学科
export function selectGzOneMajor(params) {
  return request({ url: '/api/Mojor/selectGzOneMajor',method: 'post',data: params})
}
//根据门类和一级学科查询专业
export function selectGaozhiList(params) {
  return request({ url: '/api/Mojor/selectGaozhiList',method: 'post',data: params})
}





// WEBPACK FOOTER //
// ./src/api/gw/major.js